import { ServiceTypesPageStore } from './service-types-page.store';
import { fb, translate } from '../../../../modules/shared/shared.global-service';
import { Component, computed, inject } from '@angular/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { getExpertisesFrag, getServiceTypesFrag } from './service-types-page.query';
import { ExpertisesObject, ServiceTypeGridItemObject } from '@it2go/types';
import { Router } from '@angular/router';
import { nameColumn } from '../../../../modules/shared/components/kit/table/table.fields';
import { serviceTypeEnumOptions } from '@libs/types/src/services/enum/service-type.enum';
import { arrayToOptions } from '@libs/types/src/common/enum/util';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-types-page',
    templateUrl: './service-types-page.component.html',
    styleUrl: './service-types-page.component.scss',
    providers: [ServiceTypesPageStore],
    imports: [
        TableComponent,
        PrimeTemplate,
    ],
})
export class ServiceTypesPageComponent {

    protected readonly store = inject(ServiceTypesPageStore);
    protected readonly router = inject(Router);

    protected form = fb.group({});
    protected prefix = 'serviceType.';

    protected additionalFilter = computed(() => {
        const filter = new FilterBuilder();
        filter.organizationId(this.store.globalGlobalStore.organizationStore.selectedId());
        if (this.store.isAllowedGlobal('system.read')) {
            filter.orWhere('organizationId', '', 'EMPTY');
        }

        return filter.filter().filter;
    });

    protected columns = computed(() => {
        return [
            nameColumn,
            {
                name: 'type',
                sortable: true,
                data: (item: any) => translate.instant(`serviceType.types.${item}`),
                filterable: {
                    type: 'select',
                    selectOptions: () => serviceTypeEnumOptions,
                },
            },
            {
                name: 'expertise',
                sortable: true,
                dataKey: 'expertise.code',
                filterable: {
                    type: 'select',
                    selectOptions: () => arrayToOptions(
                        this.store.data.getExpertises()
                            ?.items
                            ?.map((it: ExpertisesObject) => it.code)
                        || [],
                    ),
                },
            },
        ];
    });

    constructor() {
        this.store.api.getExpertises(FilterBuilder.singlePage(), getExpertisesFrag);
    }

    protected async detailCallback(item: ServiceTypeGridItemObject): Promise<void> {
        await this.router.navigateByUrl(`content/system/service-type/${item.id}`);
    }

    protected readonly getServiceTypesFrag = getServiceTypesFrag;
}
